jQuery( document ).ready( function ( $ ) {
	function LATESTPOSTS( context ) {
		const blockName = 'jtf/jtf-latestpost'
		console.log( '[JTF Gut Block - JS] ' + blockName + ' v2.10' )
		this.context = context
		this.offset = 0
		this.taxTerms = []
		this.taxToggleContainer = []
		this.init()
		this.textLimit = context.find( '.jtf__block' ).attr( 'data-textlimit' )
		this.textLimitType = context.find( '.jtf__block' ).attr( 'data-textlimittype' )

		const allTermsButton = $( '<button/>',
			{
				'class': 'btn btn__default jtf__latestpostsblock--tax-link',
				'href': '#',
				'title': 'All',
				'data-target': 'all',
			},
		)
		allTermsButton.html( 'All' )
		this.taxToggleContainer.push( allTermsButton )

	}

	function dateSuffix( d ) {
		if ( d > 3 && d < 21 ) {
			return 'th'
		}
		switch ( d % 10 ) {
			case 1:
				return "st"
			case 2:
				return "nd"
			case 3:
				return "rd"
			default:
				return "th"
		}
	}

	/**
	 * Get posts from WPAPI on the same website you're sending from
	 *
	 * @param postType
	 * @param perPage
	 * @param colCount
	 * @param container
	 * @param offset
	 */
	LATESTPOSTS.prototype.getPosts = function ( postType, perPage, colCount, container, offset, thisReadMoreLink, thisAuthor, thisAuthorsetting, thisTheme, thisExcerpt, thisDate, thisTaxFilter, thisCategory, thisTermVisiblity, thisTerm, thisRandomisation, thisRandomId, thisAccent, thisTimer, thisAuthFiltType, thisAuthFiltVal, thisHeadingLevel ) {
		//console.log( 'getPosts' )
		console.log(
			'postType: ' + postType,
			'perPage: ' + perPage,
			'colCount: ' + colCount,
			'container: ' + container,
			'offset: ' + offset,
			'thisReadMoreLink: ' + thisReadMoreLink,
			'thisAuthor: ' + thisAuthor,
			'thisAuthorsetting: ' + thisAuthorsetting,
			'thisTheme: ' + thisTheme,
			'thisExcerpt: ' + thisExcerpt,
			'thisDate: ' + thisDate,
			'thisTaxFilter: ' + thisTaxFilter,
			'thisCategory: ' + thisCategory,
			'thisTermVisiblity: ' + thisTermVisiblity,
			'thisTerm: ' + thisTerm,
			'thisRandomisation: ' + thisRandomisation,
			'thisRandomId: ' + thisRandomId,
			'thisAuthFiltType: ' + thisAuthFiltType,
			'thisAuthFiltVal: ' + thisAuthFiltVal,
			'thisHeadingLevel' + thisHeadingLevel,
		)

		const self = this
		let url = '/wp-json/jtf/v1/post/latest?per_page=' + perPage + '&offset=' + offset + '&posttype=' + postType + '&tax=' + thisCategory + '&term=' + thisTerm + '&random=' + thisRandomisation + '&authortype=' + thisAuthFiltType + '&authorvalue=' + thisAuthFiltVal

		self.context.find( '.jtf__latestpostsblock--preloader' ).show()

		$.ajax(
			{
				dataType: 'json',
				data: '',
				url: url,
				success: function ( response ) {
					const json = response

					self.context.find( '.jtf__latestpostsblock--preloader' ).fadeOut()

					if ( json.length == 0 && container.parents( '.container' ).find( '.jtf__latestpostsblock--loadmore-trigger' ).length > 0 ) {
						self.context.find( '.jtf__latestpostsblock--loadmore-trigger' ).prop( 'disabled', true )
					}


					if ( thisTaxFilter != 'false' ) {
						// Loop through returned posts to find all the categories they have assigned
						for ( let z = 0; z < json.length; z++ ) {
							if ( json[ z ].taxonomies[ thisTaxFilter ] != false ) {
								let allTerms = json[ z ].taxonomies[ thisTaxFilter ]
								for ( let a = 0; a < allTerms.length; a++ ) {
									let termName = allTerms[ a ].name
									if ( self.taxTerms.includes( termName ) == false ) {
										self.taxTerms.push( termName )
										const thisTermEl = $( '<button/>',
											{
												'class': 'btn btn__default jtf__latestpostsblock--tax-link',
												'href': '#',
												'data-target': allTerms[ a ].slug,
											},
										)
										thisTermEl.html( termName )
										self.taxToggleContainer.push( thisTermEl )
									}
								}
							}
						}

						self.context.find( '.jtf__latestpostsblock--taxonomytoggle-container' ).html( self.taxToggleContainer )
						//container.append(self.taxToggleContainer)
					}

					let colClass
					switch ( colCount ) {
						case '4':
							colClass = 'col-12 col-md-3'
							break
						case '3':
							colClass = 'col-12 col-md-4'
							break
						case '2':
							colClass = 'col-12 col-md-6'
							break
						case '1':
							colClass = 'col-12'
							break
						default:
							colClass = 'col-12 col-md-4'
					}

					for ( let x = 0; x < json.length; x++ ) {
						let termsList = ''
						if ( thisTaxFilter != 'false' ) {
							for ( let y = 0; y < json[ x ].taxonomies[ thisTaxFilter ].length; y++ ) {
								let thisTerm = json[ x ].taxonomies[ thisTaxFilter ][ y ].slug
								if ( y == json[ x ].taxonomies[ thisTaxFilter ].length - 1 ) {
									termsList += thisTerm
								} else {
									termsList += thisTerm + ','
								}
							}
						}

						// Outer container for the item - has a class of the bootstrap columnwidth set in the block settings
						const itemContainer = $( '<div/>',
							{
								'class': colClass + ' jtf__latestpostsblock--item',
								'data-parent': thisRandomId,
								//TODO ADD TERM LIST HERE TO COMPARE TO
								'data-term': termsList,
							},
						)

						if ( thisTermVisiblity == '1' ) {
							const taxContainer = $( '<div/>',
								{
									'class': 'jtf__latestpostsblock--tax',
								},
							)

							if ( thisCategory == 'true' && thisTaxFilter != 'false' ) {
								itemContainer.attr( 'data-taxonomies', json[ x ].taxonomies[ thisTaxFilter ][ 0 ].name )
								taxContainer.html( json[ x ].taxonomies[ thisTaxFilter ][ 0 ].name )
							} else if ( thisCategory == 'true' && thisTaxFilter == 'false' ) {
								for ( const taxonomy in json[ x ].taxonomies ) {
									if ( false != json[ x ].taxonomies[ taxonomy ] ) {
										itemContainer.attr( 'data-taxonomies', json[ x ].taxonomies[ taxonomy ][ 0 ].name )
										taxContainer.html( json[ x ].taxonomies[ taxonomy ][ 0 ].name )
									}
									break
								}
							} else {
								// If tax filter active, use the term filter as the displayed term -
								// cos we dont wanna display a category other than ones from within the filter
								if ( thisTaxFilter != 'false' ) {
									if ( json[ x ].taxonomies[ thisTaxFilter ] ) {
										let taxTerms = ''
										for ( let t = 0; t < json[ x ].taxonomies[ thisTaxFilter ].length; t++ ) {
											if ( t == json[ x ].taxonomies[ thisTaxFilter ].length - 1 ) {
												taxTerms += json[ x ].taxonomies[ thisTaxFilter ][ t ].slug
											} else {
												taxTerms += json[ x ].taxonomies[ thisTaxFilter ][ t ].slug + ','
											}
										}
										itemContainer.attr( 'data-taxonomies', taxTerms )
										taxContainer.html( json[ x ].taxonomies[ thisTaxFilter ][ 0 ].name )
									}
								} else {
									let taxTerms = ''
									for ( let t = 0; t < json[ x ].taxonomies[ thisCategory ].length; t++ ) {
										if ( t == json[ x ].taxonomies[ thisCategory ].length - 1 ) {
											taxTerms += json[ x ].taxonomies[ thisCategory ][ t ].slug
										} else {
											taxTerms += json[ x ].taxonomies[ thisCategory ][ t ].slug + ','
										}
									}
									itemContainer.attr( 'data-taxonomies', taxTerms )
									taxContainer.html( json[ x ].taxonomies[ thisCategory ][ 0 ].name )
								}
							}

							// Don't render tax container yet if alt 4 because order...
							if ( thisTheme != 'alt4' ) {
								itemContainer.append( taxContainer )
							} else {
							}
						}

						const imgContainer = $( '<div/>',
							{
								'class': 'jtf__latestpostsblock--img-container',
							},
						)
						// Post permalink
						const itemLink = $( '<a/>',
							{
								'href': json[ x ].permalink,
							},
						)
						// Header image
						const itemImg = $( '<img/>',
							{
								'class': 'jtf__latestpostsblock--img',
								'loading': 'lazy',
							},
						)

						if ( json[ x ].post_meta._mediabang_altimg && json[ x ].post_meta._mediabang_altimg != "[]" ) {

							let sidebar_img = JSON.parse( json[ x ].post_meta._mediabang_altimg )
							itemImg.attr( 'src', sidebar_img.url )
						} else if ( json[ x ].post_meta._header_image.attachment.large[ 0 ] ) {
							// If the image ID == 0, it's likely we don't have an image attached - so use a placeholder instead
							// Get the header image of the post by the images ID stored in the post meta
							itemImg.attr( 'src', json[ x ].post_meta._header_image.attachment.large[ 0 ] )
						} else {
							itemImg.attr( 'src', 'https://covers.tandf.co.uk/covers/TANF_MR.jpg' )
						}

						// Post Title
						const titleSection = $( '<div/>',
							{
								'class': 'jtf__latestpostsblock--titlesection',
								'style': '--accent:' + thisAccent,
							},
						)
						const itemTitle = $( '<' + thisHeadingLevel + '/>',
							{
								'class': 'jtf__latestpostsblock--title',
							},
						)
						const itemTimer = $( '<div/>',
							{
								'class': 'jtf__latestpostsblock--timer',
								'style': '--accent:' + thisAccent,
							},
						)
						const itemTimes = $( '<div/>',
							{
								'class': '',
							},
						)
						const itemTime = $( '<span/>',
							{
								'class': 'jtf__latestpostsblock--timer-time',
								'style': '--accent:' + thisAccent,
							},
						)
						const itemMin = $( '<span/>',
							{
								'class': 'jtf__latestpostsblock--timer-min',
								'style': '--accent:' + thisAccent,
							},
						)
						const itemClock = $( '<i/>',
							{
								'class': 'fa-regular fa-clock-desk',
								'style': '--accent:' + thisAccent,
							},
						)
						const itemTitleInner = $( '<a/>',
							{
								'href': json[ x ].permalink,
							},
						)
						if ( thisTimer ) {
							itemMin.text( ' min' )
							self.getPostReadtime( json[ x ].ID, itemTime )
							itemTimes.append( itemTime )
							itemTimes.append( itemMin )
							itemTimer.append( itemTimes )
							itemTimer.append( itemClock )
						}

						// If we're using the 'title above image' theme, render the title first.
						switch ( thisTheme ) {
							case 'alt2':
								itemTitleInner.text( json[ x ].post_title )
								itemTitle.append( itemTitleInner )
								titleSection.append( itemTitle )
								thisTimer ? titleSection.append( itemTimer ) : null
								itemContainer.append( titleSection )
								itemLink.append( itemImg )
								imgContainer.append( itemLink )
								itemContainer.append( imgContainer )
								break
							case 'alt4':
								itemLink.append( itemImg )
								imgContainer.append( itemLink )
								itemContainer.append( imgContainer )
								itemTitleInner.text( json[ x ].post_title )
								itemTitle.append( itemTitleInner )
								titleSection.append( itemTitle )
								thisTimer ? titleSection.append( itemTimer ) : null
								itemContainer.append( titleSection )
								break
							default:
								itemLink.append( itemImg )
								imgContainer.append( itemLink )
								itemContainer.append( imgContainer )
								itemTitleInner.text( json[ x ].post_title )
								itemTitle.append( itemTitleInner )
								titleSection.append( itemTitle )
								thisTimer ? titleSection.append( itemTimer ) : null
								itemContainer.append( titleSection )
						}

						let postPublishDate = json[ x ].post_date
						let dateAsObj = new Date( postPublishDate )
						let date = new Date( dateAsObj )
						let day = date.getDate()
						let months = [ 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec' ]
						let month = months[ date.getMonth() ]
						let year = date.getFullYear()

						switch ( thisDate ) {
							case 'true':
								const itemDateheader = $( '<span/>',
									{
										'class': 'jtf__latestpostsblock--date-date1',
									},
								)

								itemDateheader.html( day + dateSuffix( day ) + ' ' + month + ' ' + year )
								itemContainer.append( itemDateheader )
								break
							case 'besideTitle':
								const itemDatebesidesTitle = $( '<span/>',
									{
										'class': 'jtf__latestpostsblock--date-date2',
									},
								)

								itemDatebesidesTitle.html( day + dateSuffix( day ) + ' ' + month + ' ' + year )
								itemContainer.append( itemDatebesidesTitle )
								break
							case 'bottom':
								const itemDatebottom = $( '<span/>',
									{
										'class': 'jtf__latestpostsblock--date',
									},
								)

								itemDatebottom.html( day + dateSuffix( day ) + ' ' + month + ' ' + year )
								itemContainer.append( itemDatebottom )
								break
							case 'false':
							default:
						}

						if ( thisTheme == 'alt4' ) {
							itemContainer.append( "<hr>" )
							itemContainer.append( taxContainer )
						}

						if ( thisAuthor == 'true' ) {
							// Post Title
							const itemAuthor = $( '<div/>',
								{
									'class': 'jtf__latestpostsblock--author',
								},
							)
							const itemAuthorData = $( '<div/>',
								{
									'class': 'jtf__latestpostsblock--author-data',
								},
							)
							const itemAuthorName = $( '<span/>',
								{
									'class': 'jtf__latestpostsblock--author-name',
								},
							)
							let joinedName = json[ x ].author_data.first_name + ' ' + json[ x ].author_data.last_name

							// set the author name if one hasn't been set on the user (otherwise it causes spacing issues)
							if ( !json[ x ].author_data.first_name ) {
								joinedName = 'Anon'
							}
							itemAuthorName.html( joinedName )
							itemAuthorData.append( itemAuthorName )
							const itemAuthorProfile = $( '<img/>',
								{
									'class': 'jtf__latestpostsblock--author-profile',
									'src': json[ x ].author_data.avatar,
									'data-type': thisAuthorsetting,
								},
							)

							itemAuthorData.append( itemAuthorProfile )
							const itemAuthorjobtitle = $( '<div/>',
								{
									'class': 'jtf__latestpostsblock--author-jobtitle',
								},
							)
							itemAuthorjobtitle.html( json[ x ].author_data.job_title )
							itemAuthorData.append( itemAuthorjobtitle )
							itemAuthor.append( itemAuthorData )
							itemContainer.append( itemAuthor )
						}
						if ( thisExcerpt == 'true' ) {
							// Post Copy Extract
							const itemCopy = $( '<div/>',
								{
									'class': 'jtf__latestpostsblock--copy',
								},
							)
							const itemCopyContainer = $( '<p/>' )
							var trimmedString = ''

							if ( json[ x ].post_excerpt ) {
								var string = self.stripHtml( json[ x ].excerpt )

								//thisTheme == 'alt5' ? length = 100 : length = 300
								if ( self.textLimitType == 'wordlim' ) {
									let copy = string.split( " " )
									let renderString = ''
									for ( let x = 0; x < self.textLimit; x++ ) {
										renderString += ' ' + copy[ x ]
									}
									trimmedString = renderString
								} else {
									trimmedString = string.substring( 0, self.textLimit )
								}
								itemCopyContainer.text( trimmedString + ' ...' )
								itemCopy.append( itemCopyContainer )
								itemContainer.append( itemCopy )
							} else {
								var string = self.stripHtml( json[ x ].post_content )
								if ( self.textLimitType == 'wordlim' ) {
									let copy = string.split( " " )
									let renderString = ''
									for ( let x = 0; x < self.textLimit; x++ ) {
										renderString += ' ' + copy[ x ]
									}
									trimmedString = renderString
								} else {
									trimmedString = string.substring( 0, self.textLimit )
								}
								itemCopyContainer.text( trimmedString + ' ...' )
								itemCopy.append( itemCopyContainer )
								itemContainer.append( itemCopy )
							}
						}

						// Read More link
						const readMoreLink = $( '<a/>',
							{
								'class': 'jtf__latestpostsblock--readmore btn btn__default',
								'href': json[ x ].permalink,
							},
						)
						readMoreLink.append( 'Read more' )
						thisReadMoreLink == '1' ? itemContainer.append( readMoreLink ) : null
						container.append( itemContainer )
						self.filterPosts( 'all', thisRandomId )
					}
				},
				error: function ( jqXHR, textStatus, errorThrown ) {
					console.log( 'AJAX error: ' + jqXHR + " | " + textStatus + " | " + errorThrown )
				},
			},
		)
	}

	LATESTPOSTS.prototype.getPostReadtime = function ( id, element ) {
		const xhr = new XMLHttpRequest()
		let url = '/wp-json/jtf/v1/string/readtime?id=' + id
		xhr.open( 'GET', url )
		xhr.onload = function ( response ) {
			if ( xhr.status === 200 ) {
				const json = JSON.parse( response.currentTarget.response )
				element.text( json )
			}
		}
		xhr.send()
	}

	/**
	 * Strips HTML from a string (used to strip HTML from post content)
	 *
	 * @param html
	 * @returns {string|string}
	 */
	LATESTPOSTS.prototype.stripHtml = function ( html ) {
		const tmp = document.createElement( "DIV" )
		tmp.innerHTML = html
		return tmp.textContent || tmp.innerText || ""
	}

	LATESTPOSTS.prototype.generateRandomString = function ( length ) {
		var result = ''
		var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
		var charactersLength = characters.length
		for ( var i = 0; i < length; i++ ) {
			result += characters.charAt( Math.floor( Math.random() * charactersLength ) )
		}
		return result
	}

	LATESTPOSTS.prototype.filterPosts = function ( thisTarget ) {
		let active = []
		const self = this
		if ( active.includes( thisTarget ) ) {
			for ( var i = 0; i < active.length; i++ ) {
				if ( active[ i ] === thisTarget ) {
					active.splice( i, 1 )
				}
			}
		} else {
			active.push( thisTarget )
		}

		for ( let a = 0; a < active.length; a++ ) {
			self.context.find( '.jtf__latestpostsblock--item' ).each( function () {
				$( this ).hide()
				if ( $( this ).attr( 'data-term' ) ) {
					let taxArr = $( this ).attr( 'data-term' ).split( ',' )
					for ( let y = 0; y < taxArr.length; y++ ) {
						if ( active[ a ] == taxArr[ y ] || 'all' == active[ a ] ) {
							$( this ).show()
						}
					}
				} else {
					$( this ).show()
				}
			} )
		}
	}

	/**
	 * Default actions happening on device actions
	 */
	LATESTPOSTS.prototype.init = function () {
		const self = this

		self.context.on( 'click', '.jtf__latestpostsblock--tax-link', function ( e ) {
			e.preventDefault()
			const thisParentId = $( this ).attr( 'data-parent' )
			let thisParent = $( '#' + thisParentId )
			let thisTarget = $( this ).attr( 'data-target' )
			blockContext.find( '.jtf__latestpostsblock--tax-link' ).not( $( this ) ).removeClass( 'jtf__latestpostsblock--item-active' )
			$( this ).addClass( 'jtf__latestpostsblock--item-active' )
			thisParent.find( '.jtf__latestpostsblock--item' ).removeClass( 'jtf__latestpostsblock--item-filtered' )
			if ( thisParent.find( '.jtf__latestpostsblock--item-active' ).length > 0 ) {
				thisParent.addClass( 'jtf__latestpostsblock--filter-active' )
			} else {
				thisParent.removeClass( 'jtf__latestpostsblock--filter-active' )
			}

			self.filterPosts( thisTarget )
		} )

		const blockContext = self.context.find( '.jtf__latestpostsblock' )
		const containerTarget = blockContext
		//const postType = blockContext.attr( 'data-type' )
		//const colCount = blockContext.attr( 'data-cols' )
		//const postCount = blockContext.attr( 'data-count' )
		const thisReadMoreLink = blockContext.attr( 'data-readmore' )
		const thisAuthor = blockContext.attr( 'data-author' )
		const thisExcerpt = blockContext.attr( 'data-excerpt' )
		const thisTheme = blockContext.attr( 'data-theme' )
		const thisDate = blockContext.attr( 'data-date' )
		const thisTaxFilter = blockContext.attr( 'data-taxfilter' )
		const thisTermVisiblity = blockContext.attr( 'data-termvisibility' )
		const thisTerm = blockContext.attr( 'data-term' )
		const thisCategory = blockContext.attr( 'data-category' )
		const thisAuthorsetting = blockContext.attr( 'data-authorsettings' )
		const thisRandomisation = blockContext.attr( 'data-random' )
		const thisAccent = blockContext.attr( 'data-accent' )
		const thisTimer = blockContext.attr( 'data-timer' )
		const thisRandomId = 'jtf__latestpostsblock--parent-' + self.generateRandomString( 5 )

		// Assign a random ID to the parent, so we can use it for instatiation targeting later
		blockContext.attr( 'id', thisRandomId )
		blockContext.find( '.jtf__latestpostsblock--tax-link' ).each( function () {
			// Make a note of the parents ID on the filter links, so we can use that for targeting the correct parent later
			blockContext.attr( 'data-parent', thisRandomId )
			self.taxTerms.push( blockContext.text() )
		} )

		// Assign the same parent to each of the child items
		blockContext.find( '.jtf__latestpostsblock--item' ).each( function () {
			blockContext.attr( 'data-parent', thisRandomId )
		} )

		// bind the click event to the trigger but ONLY in this instantiation
		blockContext.parent().find( '.jtf__latestpostsblock--loadmore-trigger' ).click( function ( e ) {
			const thisPostType = blockContext.attr( 'data-type' )
			const thisPostCount = blockContext.attr( 'data-count' )
			const thisColCount = blockContext.attr( 'data-cols' )
			const thisAuthFiltType = blockContext.attr( 'data-authfilttype' )
			const thisAuthFiltVal = blockContext.attr( 'data-authfiltval' )
			const thisHeadingLevel = blockContext.attr( 'data-headinglevel' )
			const offset = parseInt( self.offset ) + parseInt( thisPostCount )

			if ( thisPostType ) {
				e.preventDefault()
			}
			self.offset = offset

			self.getPosts(
				thisPostType,
				thisPostCount,
				thisColCount,
				containerTarget,
				offset,
				thisReadMoreLink,
				thisAuthor,
				thisAuthorsetting,
				thisTheme,
				thisExcerpt,
				thisDate,
				thisTaxFilter,
				thisCategory,
				thisTermVisiblity,
				thisTerm,
				thisRandomisation,
				thisRandomId,
				thisAccent,
				thisTimer,
				thisAuthFiltType,
				thisAuthFiltVal,
				thisHeadingLevel,
			)
		} )
	}

	// Check LATESTPOSTS is used on this page before instantiating
	if ( $( '.wp-block-jtf-jtf-latestpost' ).length > 0 ) {
		$( '.wp-block-jtf-jtf-latestpost' ).each( function () {
			new LATESTPOSTS( $( this ) )
		} )

	}
} )
